import axios from "axios";

// const BASE_URL = "http://localhost:3000";
const BASE_URL = "https://sh63i7vbx5.execute-api.ap-south-1.amazonaws.com";

// const CONNECT_URL = 'https://kw41fi5rla.execute-api.ap-south-1.amazonaws.com/connect/connection'
const CONNECT_URL = "https://kw41fi5rla.execute-api.ap-south-1.amazonaws.com/";
// const CONNECT_URL = "http://localhost:3000";

const axy = axios.create({
  baseURL: BASE_URL,
});

const conapi = axios.create({
  baseURL: CONNECT_URL,
});

export const getMentorCountries = async (uni) => {
  try {
    const res = await axy.get(
      `/mentors/country?${uni ? `university=${uni}` : ""}`
    );
    console.log(res.data);
    return res;
  } catch (e) {
    return e;
  }
};

export const checkIfConnected = async (phone) => {
  try {
    const res = await conapi.post("/connect/connection", {
      phone,
    });
    console.log(res.data);
    return res;
  } catch (e) {
    return e;
  }
};
